pageId = 'page-subgroups-edit'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.initManageMembers($page)

  $('form').on 'ajax:beforeSend', (e, xhr, settings) ->
    # set ajax param members
    members = $('.member.selected').map ->
      $(@).data 'guid'
    .get()

    invitations = $('.member.invited.selected').map ->
      $(@).data 'guid'
    .get()

    settings.data += '&member_guids=' + members.join(',') + '&invitation_guids=' + invitations.join(',')
